import type { FlattenSimpleInterpolation } from 'styled-components';
import styled from 'styled-components';
import type { HeaderStyledNavItemProps } from '../../interfaces/header-styled-components.interfaces';
import { AudiCopy1WithHoverStyle } from '../AudiHeader/AudiHeaderStyleUtils';

export const HeaderStyledNavItem = styled.div<HeaderStyledNavItemProps>`
  display: block;
  padding: calc(var(--one-header-space-l) / 2) 0;

  ${({ isSmallView, theme: { breakpoints, type } }) =>
    !isSmallView &&
    `
    @media screen and (min-width: ${breakpoints.l}px) {
      margin: ${type === 'alpha' ? 'var(--one-header-alpha-menu-top-spacing) var(--one-header-space-l) 0 0;' : 'var(--one-header-space-l) var(--one-header-space-l) 0 0;'};
      padding: 0;
    }`}

  &:last-of-type {
    margin-right: 0;
  }
`;

export const HeaderStyledNavItemLink = styled.a<{
  headerNavigationItemsAmount: number;
  isSmallView: boolean;
}>`
  ${({ theme }): FlattenSimpleInterpolation => AudiCopy1WithHoverStyle(theme)}
  color: ${({ theme }): string => theme.colors.colorBaseGrey60};
  display: flex;
  ${({ theme }): string => (theme.type !== 'legacy' ? 'justify-content: space-between;' : '')}
  flex-flow: row nowrap;
  text-decoration: none;

  ${({ isSmallView, theme: { breakpoints } }) =>
    !isSmallView &&
    `@media screen and (min-width: ${breakpoints.l}px) {
      white-space: nowrap;
    }`}

  &:hover,
  &:active,
  &:focus {
    color: ${({ theme }): string =>
      theme.type === 'legacy'
        ? 'var(--one-header-color-black);'
        : 'var(--one-header-color-hover);'};
  }

  &.top-active {
    ${({ theme }): string =>
      theme.type === 'alpha' ? 'font-weight: 700;' : 'color: var(--one-header-color-black);'};
  }

  & > svg {
    height: 24px;
    width: 24px;
    ${({ isSmallView, theme: { breakpoints } }) =>
      !isSmallView &&
      `@media screen and (min-width: ${breakpoints.l}px) {
          display: none;
        }
      `}
  }
`;
